module.exports = __webpack_public_path__ + "static/img/be.6fc013c9.svg";